<script>
    import { onMount } from "svelte";
    import moment from 'moment';
    import { ModalBody, ModalFooter, ModalHeader, Modal, Label } from "sveltestrap";
    import backend from "../../../../../server";

    export let isNew =false;
    export let campaign;
    export let listCampaign
    export let showToast
    let currentTime = moment().utc().format("YYYY-MM-DD HH:mm:ss");
    let isLoading = false;
    let tipo = false; 
    let message = []; 
    let providers = [];
    let showAlert = false; 
    

     onMount(async () => {
        await getProviders();
       
        setInterval(updateTime, 1000);
     });

    const updateTime = () => {
        currentTime = moment().utc().format("YYYY-MM-DD HH:mm:ss");
    };

    const getProviders = async () => {
        try {
            let response = await backend.freespin.getProvidersNobus(); 
            if (response.data.status) { 
            providers = response.data.data.providers; 
      
            } else {
            console.error("Error: La respuesta de la API no es válida.");
            }
        } catch (error) {
            console.error("Error al obtener los proveedores:", error);
        }
    };

    $: {
    if (campaign.type !== 'random') {
      campaign.player_count = 0;
    }
  }
  
    const closeModal = () => {
        showAlert = false; 
       isNew = false;
    };

    const saveFreeSpin = async () => {
        campaign.start_date = moment(campaign.start_date).utc().format("YYYY-MM-DD HH:mm:ss");
        if (campaign.type === 'random' && !campaign.player_count) {
            message.push('Si el tipo es "random", debes proporcionar el número de jugadores.');
        }

        if (campaign.type === 'assigned' && campaign.player_count) {
            message.push('Si el tipo es "assigned", no debes enviar el número de jugadores.');
        }
    
        isLoading = true;
        showAlert = false; 
        try {

        let response = await backend.freespin.saveCampaignNovus(campaign);

        if (response.data.status) {
            message = response.data.messages;
            tipo = response.data.status;
            showToast()
            listCampaign()
            closeModal();
        } else {
            message = Array.isArray(response.data.messages) ? response.data.messages : [response.data.messages];
            tipo = response.data.status;
        }
        } catch (error) {

            message = ["Error al guardar campaña:", error.message];
        tipo = false;
        } finally {

        isLoading = false;
        showAlert = true;
        }
  }
  </script>

  
<Modal isOpen={isNew} toggle={closeModal} size="xl">
    <ModalHeader toggle={closeModal}>
      CREAR CAMPAÑAS
    </ModalHeader>
    <ModalBody>
      <div class="freeSpin-modal">
        {#if showAlert}
        <div class={`alert alert-${tipo ? 'success' : 'danger'} alert-dismissible fade show`} role="alert">
            <strong>{tipo ? '¡Éxito!' : '¡Error!'}</strong>
            {#each message as msg}
              <li>{msg}</li>
            {/each}
            <button type="button" class="btn-close" on:click={() => showAlert = false}></button>
        </div>
      {/if}
      <div class="alert alert-warning alert-dismissible fade show" role="alert" style="margin-top: 20px; margin-bottom: 20px;">
        <strong>Para crear las campañas de rondas gratuitas  y agregar jugadores a estas, deben ser de tipo "Asignado" y no de tipo "Promocional".</strong>
        <strong>¡las ¿Se puede canjear la bonificación varias veces? y ¿La campaña requiere cumplir con requisitos de apuestas? no se pueden activar al mismo tiempo!</strong>
    </div>
        <div class="row">
            <div class="col-md-4">
                <label>
                    Título de la campaña:
                    <input
                      class="form-control {isLoading && !campaign.client_campaign_title ? 'is-invalid' : ''}"
                      bind:value={campaign.client_campaign_title}
                    />
                  </label>
            </div>
            <div class="col-md-4">
                <label>
                    Número de rondas gratis:
                    <input class="form-control" bind:value={campaign.free_round_count} type="number" />
                  </label>
            </div>
            <div class="col-md-4">
                <label>
                    Número de jugadores:
                    <input class="form-control" bind:value={campaign.player_count} type="number" 
                      disabled={campaign.type !== 'random'} />
                  </label>

            </div>
          </div>

          <div class="row">
            <div class="col-md-4">
                    Proveedor: 
                    <select 
                      class="form-control " 
                      bind:value={campaign.provider_id}
                    >
                      {#each providers as provider}
                        <option value={provider.provider_id} selected={provider.provider_id == 6}>
                          {provider.provider_name}
                        </option>
                      {/each}
                    </select>
                 
          
            </div>
            <div class="col-md-4">
                Tipo de campaña:
                <select class="form-control" bind:value={campaign.type}>
                    <option value="random">Aleatoria</option>
                    <option value="assigned">Asignada</option>
                  </select>
            </div>
            <div class="col-md-4">
                <label>
                    Fecha de inicio: <strong>Hrs UTC {currentTime}</strong>
                    <input class="form-control" bind:value={campaign.start_date} type="datetime-local" />
                  </label>
            </div>
          </div>

          <div class="row">
            <div class="col-md-4">
                <label>
                    Fecha de finalización:
                    <input class="form-control" bind:value={campaign.end_date} type="datetime-local" />
                  </label>
            </div>
            <div class="col-md-4">
             
                    Estado de la campaña:
                    <select class="form-control" bind:value={campaign.is_enabled}>
                      <option value={true}>Habilitada</option>
                      <option value={false}>Deshabilitada</option>
                    </select>
                
            </div>
            <div class="col-md-4">
                
                    ¿La campaña ofrece dinero de bonificación?:
                    <select class="form-control" bind:value={campaign.is_bonus_money}>
                      <option value={true}>Sí, ofrece dinero de bonificación</option>
                      <option value={false}>No, no ofrece dinero de bonificación</option>
                    </select>
                 
            </div>
          </div>

          
      
  
  
        <div class="list-inputs">
          <label>
            ¿Esta campaña es promocional?:
            <select class="form-control" bind:value={campaign.is_promo}>
              <option value={true}>Sí, es una campaña promocional</option>
              <option value={false}>No, no es una campaña promocional</option>
            </select>
            {#if campaign.is_promo}
            <p style="color: #696b7e">
              En esta campaña no podrá agregar jugadores.
            </p>
          {/if}
          </label>
          
          
  
          <label>
            ¿Se puede canjear la bonificación varias veces? {campaign.multiple_redemptions}
            <select class="form-control" bind:value={campaign.multiple_redemptions}>
              <option value={true}>Sí, se puede canjear varias veces</option>
              <option value={false}>No, solo se puede canjear una vez</option>
            </select>
          </label>
        
        
  
          <label>
            ¿La campaña requiere cumplir con requisitos de apuestas?
            <select class="form-control" bind:value={campaign.wagering.is_enabled}>
              <option value={true}>Sí, requiere cumplir con requisitos de apuestas</option>
              <option value={false}>No, no requiere cumplir con requisitos de apuestas</option>
            </select>
          </label>
        </div>
  
        {#if campaign.wagering.is_enabled}
          <div class="list-inputs">
            <label>
              Multiplicador de apuestas:
              <input type="number" class="form-control" bind:value={campaign.wagering.multiplier} />
            </label>
  
            <label>
              Fecha de expiración de los requisitos de apuestas:
              <input type="datetime-local" class="form-control" bind:value={campaign.wagering.expiring_at} />
            </label>
  
            <label>
              Tipo de condición de apuesta:
              <input type="number" class="form-control" bind:value={campaign.wagering.bet_condition_type} min="1" />
            </label>
          </div>
        {/if}
      </div>
    </ModalBody>
  
    <ModalFooter>
      <button class="btn btn-primary" on:click={saveFreeSpin} disabled={isLoading}>
        {#if isLoading}
          <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          Cargando...
        {:else}
          Guardar
        {/if}
      </button>
    </ModalFooter>
  </Modal>
  
  
  <style>
    .freeSpin-modal{
        display: flex;
        flex-direction: column;
        gap: 1rem;
    }
    .list-inputs{
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        gap: 1rem;
    }
    select{height: 41px;}
    label {
        display: inline-block;
        color: black;
        font-weight: 500;
    }
    .is-invalid {
    border-color: red;
    }
    
  
  </style>